import React from 'react';
import PropTypes from 'prop-types';

import Processing from '../../components/Processing';
import Api from '../../Api';

export default class SignOut extends React.Component {
  componentDidMount() {
    let returnToRoot = function(response) {
      this.context.router.push('/');
      return(response);
    };
    returnToRoot = returnToRoot.bind(this);

    Api.userLogout().then(
      () => {
        return Api.resetLastSelectedRetailer().then(returnToRoot, returnToRoot);
      },
      returnToRoot
    );
  }

  render() {
    return(
      <div className="signout-component fullscreen-component center-inside">
        <Processing />
      </div>
    );
  }
}

SignOut.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/user/signout.js
 **/